import cookies from 'react-cookies';
import { Dispatch } from 'redux';
import billingDomains from '~/src/constants/billingDomains';
import { getCities } from '~/src/api/content/geography/get-all-cities';
import { TGetState } from '~/src/store';
import {
    TSetCityList, TSetCurrentCity, TFetchProvider, SET_CURRENT_CITY, FETCH_PROVIDER, SET_CITIES_LIST
} from '~/src/store/reducers/city';
import { getProviderId } from '~/src/api/provider/providerRequester';
import { PROVIDER_OPERATOR, PROVIDER_SECTOR } from '~/src/constants';
import { captureException } from '@sentry/node';

export function getCitiesList() {
    return async(dispatch: Dispatch<TSetCityList>): Promise<void> => {
        try {
            const citiesList = await getCities();

            if (!citiesList || !Array.isArray(citiesList)) {
                return;
            }

            dispatch({
                type: SET_CITIES_LIST,
                payload: {
                    citiesList,
                },
            });
        } catch (error) {
            captureException(error);
        }
    };
}

export function setCurrentCity(cityDomain: string) {
    return (dispatch: Dispatch<TSetCurrentCity>, getState: TGetState): void => {
        const state = getState();
        const { currentCity, citiesList } = state.city;

        if (currentCity.domain === cityDomain) {
            return;
        }

        const findCity = citiesList.find(city => city.domain === cityDomain);

        if (findCity) {
            const partialCity = {
                domain: findCity.domain,
                name: findCity.name,
                cityId: findCity.city_id,
                phone: findCity.phone_code === '0' ? findCity.sale_phone : `+7 (${findCity.phone_code}) ${findCity.sale_phone}`,
                callCenter: findCity.call_center_phone.length > 10 ? findCity.call_center_phone : `+7 (${findCity.phone_code}) ${findCity.call_center_phone}`,
                billingHost: findCity.billing_host,
                cityIn: findCity.pred_name,
                billingDomain: billingDomains[findCity.domain] || findCity.domain,
                internet: !!+findCity.has_internet,
                ctv: !!+findCity.has_ctv,
                ktv: !!+findCity.has_ktv,
                telephony: !!+findCity.has_telephony,
                phoneCode: findCity.phone_code === '0' ? 0 : findCity.phone_code,
                supportPhone: findCity.support_phone,
                props: findCity.props || {},
                companyName: findCity.company_name,
                logo: findCity.logo,
                region: findCity.region || null,
                abnTests: findCity.abnTests,
                hasFreeDeliveryAndInstallation: !!+findCity.has_free_delivery_and_installation,
                has_QPS: findCity.has_QPS,
                plAvailable: findCity.pl_available,
                loyaltyProgramCashback: findCity.loyalty_program_cashback,
            };

            dispatch({
                type: SET_CURRENT_CITY,
                payload: {
                    currentCity: partialCity,
                },
            });
        }
    };
}

export function getProvider() {
    return async(dispatch: Dispatch<TFetchProvider>, getState: TGetState): Promise<void> => {
        const store = getState();
        const { cityId } = store.city.currentCity;

        const additionalData = await getProviderId({
            sector: PROVIDER_SECTOR,
            operatorId: PROVIDER_OPERATOR,
            cityId: cityId
        });

        if (additionalData.isSuccess) {
            dispatch({
                type: FETCH_PROVIDER,
                payload: {
                    provider: additionalData.payload,
                },
            });
            cookies.save('provider', additionalData.payload.providerId, { path: '/' });
        }
    };
}
